module.exports = __webpack_public_path__ + "static/img/q1.be773af2.jpg";